module.exports = __webpack_public_path__ + "static/media/tastr-image.c1bb8d4a.png";